import React from 'react';
import Tooltip from '../../tooltips/Tooltips';

/**
 * Composant réutilisable pour un texte cliquable avec effet de survol similaire à un bouton secondary
 * @param {React.ReactNode} children - Contenu à afficher
 * @param {function} onClick - Fonction appelée au clic
 * @param {string} className - Classes CSS additionnelles
 * @param {string} tooltipText - Texte du tooltip (optionnel)
 * @param {string} tooltipPlacement - Placement du tooltip (optionnel, défaut: 'top')
 */
const ClickableText = ({ 
  children, 
  onClick, 
  className = '', 
  tooltipText,
  tooltipPlacement = 'top' 
}) => {
  const hasLineClamp = className.includes('line-clamp');
  const lineClampValue = className.match(/line-clamp-(\d+)/)?.[1] || '2';
  
  const content = (
    <span 
      className={`px-2 py-1 rounded hover:bg-gray-100 transition-colors cursor-pointer ${hasLineClamp ? 'block' : 'inline-block'} ${className}`}
      onClick={onClick}
      style={hasLineClamp ? { 
        display: '-webkit-box', 
        WebkitLineClamp: lineClampValue, 
        WebkitBoxOrient: 'vertical', 
        overflow: 'hidden',
        wordBreak: 'break-word'
      } : {}}
    >
      {children}
    </span>
  );

  if (tooltipText) {
    return (
      <Tooltip text={tooltipText} placement={tooltipPlacement}>
        {content}
      </Tooltip>
    );
  }

  return content;
};

export default ClickableText;

